import { useContext } from 'react';

import { StepsFormContext } from '../contexts/StepsContext';

export const useStepsForm = () => {
  const context = useContext(StepsFormContext);
  if (context === undefined) {
    throw new Error(
      'useStepsForm necessita ser utilizado dentro de StepsFormProvider'
    );
  }
  return context;
};
